import { DotFlashing, FieldLabel, FlexRowDiv, HeaderDiv } from "../../styledComponents/Components.styles";
import palette from "../../../utilities/palette";

export default function SwPartNumberLabelField ({
    value,
    cursor,
    errorMessage = "",
    isLoading = false,
}: Readonly<{
    value: string,
    cursor?: string,
    errorMessage?: string,
    isLoading?: boolean,
}>) {
    return (
        <HeaderDiv style={{display: 'flex', flexDirection: 'column', gap: "5px"}}>
            <FieldLabel variant="header" style={{cursor: cursor ? "pointer" : "default" }} >
                Software Part Number
            </FieldLabel>

            {isLoading ? 
            <FlexRowDiv style={{gap: '10px', alignItems: 'center'}}>
                <span style={{color: palette.main, fontSize: 18, fontWeight: 400}}>Processing</span>
                <DotFlashing size="medium" />
            </FlexRowDiv>
            :
            <label style={{fontSize: errorMessage ? 16 : 18, color: errorMessage ? palette.stepper.error : palette.main, cursor: cursor ? "pointer" : "grey", fontWeight: errorMessage ? 100 : 600 }} >
                {errorMessage ? errorMessage : value}
            </label>
        }
            
            
        </HeaderDiv>
    )
}